












import { Component, Prop, Vue } from "vue-property-decorator";
import {
  ConcisenessRepetition,
  SentenceLengthDistribution
} from "../../../types/NewResults";

// import AssetsMixin from "@/AssetsMixin";
// import Card from "../Card.vue";

@Component({
  components: {}
})
export default class AwkPause extends Vue {
  @Prop() private count!: Number;
}
